<div class="m-3 p-2 border bg-white">
  <div>Delete "{{menuItem.title}}"?</div>
  <div>
    <a [routerLink]="['/admin','content','menu-item', menuItem.id]" class=" btn btn-outline-danger">Cancel</a>
    <a (click)="delete()" class=" btn btn-primary">Delete</a>
  </div>
</div>
